<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="登录时间/变更时间：">
        <el-select v-model="query.type" placeholder="请选择" size="small">
          <el-option label="登录时间" :value="1"></el-option>
          <el-option label="变更时间" :value="2"></el-option>
        </el-select>
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
import { filterEmpty } from '@/utils'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        type: 1,
      },

    }
  },
  created() {
  },
  methods: {
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      return this.$common.confirm('是否确认导出')
        .then(() => sysDataCompareLogApi.exportLoginLog(filterEmpty(this.query))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>